/**
 * The global nav, and the copy on the screens it reaches.
 *
 * Title Case is for round labels — the names a facilitator says out loud. These
 * are destinations, so they follow the frames and take a capital as proper
 * nouns of the app, and everything under them is sentence case.
 */

export const NAV_CUSTOMERS = "Customers"
export const NAV_SESSIONS = "Sessions"
export const NAV_DECK = "Deck"
export const NAV_REPORTS = "Reports"
export const NAV_ARCHIVE = "Archive"

export const NAV_SEARCH = "Search"
export const SEARCH_PLACEHOLDER = "Search customers and sessions"
/** Said plainly, because the limit is real — see §5.5 of the redesign plan. */
export const SEARCH_SCOPE = "Searches what is already loaded, by name."
export const SEARCH_EMPTY = "Nothing matches that."

export const NAV_NO_CUSTOMERS = "No customers yet"
export const NAV_NO_SESSIONS = "No sessions yet"
export const NAV_ALL_CUSTOMERS = "All customers"
export const NAV_ALL_SESSIONS = "All sessions"

export const SESSIONS_TITLE = "Sessions"
export const SESSIONS_BLURB = "Every session you can open, newest first."
export const SESSIONS_EMPTY = "No sessions yet. Start one from a customer."

export const DECK_TITLE = "Browse by what AI can do."
export const DECK_BLURB = "The whole deck, outside a session."

export const REPORTS_TITLE = "Reports"
export const REPORTS_BLURB = "One debrief per finished session."
export const REPORTS_EMPTY = "No finished sessions yet."

export const TABLE_CUSTOMER = "Customer"
export const TABLE_SESSION = "Session"
export const TABLE_DATE = "Date"
export const TABLE_STATUS = "Status"
export const TABLE_PARTICIPANTS = "Participants"
export const TABLE_VIEW = "View Case"
export const TABLE_REPORT = "View report"
